import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import {
  BaSeParagraph,
  BaSeInput,
  BaSeButton,
  BaSeTheme,
  BaSeDialogContext,
} from '@base/react';
import { stringToMoney } from '../../utils/string-to-money';
import { useEmpresa } from '../../../../services/empresa/EmpresaService';
import { useLancamento } from '../../../../services/lancamento/LancamentoService';

export const SaldoBaseModal = ({
  value,
  closeModal,
  empresa,
  isUpdate,
  atualizaEmpresa,
}) => {
  const [saldo, setValue] = React.useState(value ?? '0');
  const [loading, setLoading] = React.useState(false);
  const { navigateTo } = Sebrae.useRouter();
  const { showNotification } = React.useContext(BaSeDialogContext);

  const { salvarRegistro, alterarSaldo } = useEmpresa();
  const { lancamentoAutomaticoMei } = useLancamento();

  const handleSave = React.useCallback(() => {
    const obj = {
      saldo: stringToMoney(saldo),
      empresa: {
        cnpj: empresa?.cnpj,
        id: empresa?.id,
      },
    };
    const year = new Date().getFullYear();
    setLoading(true);
    const res = !empresa?.id ? salvarRegistro(obj) : alterarSaldo(obj);
    res.then(async (idre) => {
      if (!isUpdate) {
        await lancamentoAutomaticoMei(empresa.cnpj, year).catch(() => {
          console.log('erro');
        });
        navigateTo('/lancamentos');
      }
      showNotification({
        color: 'confirmation',
        message: 'Sucesso',
        supportMessage: 'Registro Salvo com Sucesso!',
      });
      atualizaEmpresa(empresa?.id ? { ...empresa } : { ...empresa, id: idre });
      closeModal();
    });
  }, [
    alterarSaldo,
    atualizaEmpresa,
    closeModal,
    empresa,
    isUpdate,
    lancamentoAutomaticoMei,
    navigateTo,
    saldo,
    salvarRegistro,
    showNotification,
  ]);

  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'column',
        gap: 24,
      }}
    >
      <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
        Ok! agora nos informe qual o saldo atual de seu caixa. E não se preocupe
        pois o Sebrae mantém os dados de sua empresa de forma segura.
      </BaSeParagraph>
      <BaSeInput
        label="Saldo atual"
        value={saldo}
        onChange={setValue}
        mask="decimal"
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <BaSeButton
          isLoading={loading}
          isDisabled={!saldo}
          value="Salvar"
          onClick={() => handleSave()}
        />
        <BaSeButton
          type="secondary"
          value="Voltar"
          onClick={() => closeModal?.()}
        />
      </div>
    </div>
  );
};
